export const SNACK_CONSTANTS = {
  TYPE: {
    SUCCESS: 'success',
    ERROR: 'error',
  },
  ACTION: {
    OK: 'OK',
  },
} as const;
